import businessDomainService from '@/apps/data-platform/services/master_data/business_domain_service';
import businessSubdomainService from '@/apps/data-platform/services/master_data/business_subdomain_service';
import businessTermService from '@/apps/data-platform/services/master_data/business_term_service';
import DataProfilingService from '@/apps/data-platform/services/data_quality/data_profiling_service';
import ProfilingScoreService from '@/apps/data-platform/services/data_quality/profiling_score_service';
import ValidationTypeService from '@/apps/data-platform/services/data_quality/validation_type_service';
import InitialSetupService from '@/apps/data-platform/services/tables_views/initial_setup_service';
import MasterDataService from '@/apps/data-platform/services/master_data/master_data_service';
import userSettingsService from '@/apps/data-platform/services/security/user_settings_service';
import VisualizationService from '@/apps/data-platform/services/visualization/visualization_service';
import DomainService from '@/apps/data-platform/services/master_data/domain_service';
import { MENU_DICT } from '@/js/constants';
import user_security_service from '../services/security/user_security_service';
import firebase from 'firebase/app';
export default {
  namespaced: true,
  state: {
    select_areas: [],
    select_business_domains: [],
    select_business_subdomains: [],
    select_zones: [],
    select_profiling_validation_type: [],
    score_field_types: [],
    score_table_rules: [],
    profiling_executions: [],
    profiling_execution: {},
    initial_setup_records: [],
    ds_response_text: '',
    inca_base_url: '',
    isDomainItc: false,
    isTableauActive: false,
    isTableauAccessFunction: false,
    isTableauMultipleAccess: false,
    isPowerBIActive: false,
    isPowerBIAccessFunction: false,
    isPowerBIMultipleAccess: false,
    isDataStudioActive: false,
    isDataStudioFunction: false,
    mainQueryBy: '',
    mainQueryText: '',
    mainQueryAdvance: '',
    selectDomain: [],
    selectSubdomain: [],
    selectBusinessTerm: [],
    organizations: [],
    companyCode: '',
    companyName: '',
    orgs: [],
    domains_optional: [],
    defaultLanguage: 'es',
    messagingToken: null,
    newNotifications: 0,
    userNotifications: [],
    projects: {},
    catalogs: {},
    isSynapseActive: false,
    isSynapseAccessFunction: true,
    isBigqueryAccessFunction: true,
    filtrosbusqueda: {
      object: "[{'text':'Tablas','value': 'table'},{'text':'Vistas','value': 'view'}]",
      query_by: "[{'text': 'Título', 'value': 'titulo'}]",
      per_page: 10,
      page: 1,
      final_table: 'all',
      semanticSearch: false
    },
    dataplex_dimensions: [],
    dataplex_expectations: [],
    dataplex_rules: [],
    has_dataplex_active: false,
    deploy_version: '2.0.0',
    has_semantic_search_active: false,
    has_hub_ia_active: false,
    has_dataplex_catalog_active: false
  },
  mutations: {
    setDeployVersion: function setDeployVersion(state, data) {
      state.deploy_version = data;
    },
    setHasDataplexActive: function setHasDataplexActive(state, data) {
      state.has_dataplex_active = data;
    },
    setHasDataplexCatalogActive: function setHasDataplexCatalogActive(state, data) {
      state.has_dataplex_catalog_active = data;
    },
    setHasHubIaActive: function setHasHubIaActive(state, data) {
      state.has_hub_ia_active = data;
    },
    setHasSemanticSearchActive: function setHasSemanticSearchActive(state, data) {
      state.has_semantic_search_active = data;
    },
    guardarfiltrosbusqueda: function guardarfiltrosbusqueda(state, nuevoObjeto) {
      state.filtrosbusqueda = nuevoObjeto;
    },
    setOrgs: function setOrgs(state, payload) {
      state.orgs = payload;
    },
    setDomainsOptional: function setDomainsOptional(state, payload) {
      state.domains_optional = payload;
    },
    setDataplexDimensions: function setDataplexDimensions(state, payload) {
      state.dataplex_dimensions = payload;
    },
    setDataplexExpectations: function setDataplexExpectations(state, payload) {
      state.dataplex_expectations = payload;
    },
    setDataplexRules: function setDataplexRules(state, payload) {
      state.dataplex_rules = payload;
    },
    setCompanyCode: function setCompanyCode(state, payload) {
      state.companyCode = payload;
    },
    setCompanyName: function setCompanyName(state, payload) {
      state.companyName = payload;
    },
    set_select_fields: function set_select_fields(state, payload) {
      state.select_areas = payload.areas || [];
      state.selectDomain = payload.business_domains || [];
      state.selectSubdomain = payload.business_subdomains || [];
      state.organizations = payload.organizations || [];
    },
    set_initial_setup_records: function set_initial_setup_records(state, payload) {
      if (payload) {
        var index = 0;
        payload.data.forEach(function (element) {
          index += 1;
          element.index = index;
        });
      }
      state.initial_setup_records = payload && payload.data || [];
    },
    set_ds_response_text: function set_ds_response_text(state, payload) {
      state.ds_response_text = payload.texto || {};
    },
    setIsDomainItc: function setIsDomainItc(state, payload) {
      state.isDomainItc = payload || false;
    },
    setSynapseStatus: function setSynapseStatus(state, payload) {
      state.isSynapseActive = 'has_synapse' in payload ? payload.has_synapse : false;
      state.isSynapseAccessFunction = 'has_access_function' in payload ? payload.has_access_function : true;
    },
    setBigqueryStatus: function setBigqueryStatus(state, payload) {
      console.log('bigquery', payload);
      state.isBigqueryAccessFunction = 'has_access_function' in payload ? payload.has_access_function : true;
    },
    setIsTableauActive: function setIsTableauActive(state, payload) {
      state.isTableauActive = payload.has_tableau;
      state.isTableauAccessFunction = payload.has_access_function;
      state.isTableauMultipleAccess = payload.has_tableau_multiple_access;
      state.isPowerBIActive = payload.has_powerbi;
      state.isPowerBIAccessFunction = payload.has_powerbi_access_function;
      state.isPowerBIMultipleAccess = payload.has_powerbi_multiple_access;
      state.isDataStudioActive = payload.has_datastudio;
      state.isDataStudioFunction = payload.has_datastudio_access_function;
      state.organizations = payload.organizations;
      state.select_zones = payload.zones;
    },
    setMainQueryBy: function setMainQueryBy(state, queryBy) {
      state.mainQueryBy = queryBy;
    },
    setMainQueryText: function setMainQueryText(state, queryText) {
      state.mainQueryText = queryText;
    },
    setMainQueryAdvance: function setMainQueryAdvance(state, query) {
      state.mainQueryAdvance = query;
    },
    setSelectDomain: function setSelectDomain(state, selectDomain) {
      state.selectDomain = selectDomain;
    },
    setSelectSubdomain: function setSelectSubdomain(state, selectSubdomain) {
      state.selectSubdomain = selectSubdomain;
    },
    setSelectProfilingValidationType: function setSelectProfilingValidationType(state, payload) {
      state.select_profiling_validation_type = payload && payload.data || [];
    },
    setProfilingScoreFieldType: function setProfilingScoreFieldType(state, payload) {
      state.score_field_types = payload && payload.data || [];
    },
    setProfilingScoreTableRule: function setProfilingScoreTableRule(state, payload) {
      state.score_table_rules = payload && payload.data || [];
    },
    setProfilingExecutions: function setProfilingExecutions(state, payload) {
      state.profiling_executions = payload && payload.data || [];
      state.profiling_execution = state.profiling_executions.length > 0 ? state.profiling_executions[0] : {};
    },
    setProfilingExecution: function setProfilingExecution(state, execution_id) {
      if (state.profiling_executions.length > 0) {
        state.profiling_execution = state.profiling_executions.find(function (e) {
          return e.document_id === execution_id;
        });
      } else {
        state.profiling_execution = {};
      }
    },
    setSelectBusinessTerm: function setSelectBusinessTerm(state, datos) {
      state.selectBusinessTerm = datos;
    },
    setDefaultLanguage: function setDefaultLanguage(state, language) {
      state.defaultLanguage = language;
    },
    setBaseUrl: function setBaseUrl(state, base_url) {
      state.inca_base_url = base_url;
    },
    setMessagingToken: function setMessagingToken(state, token) {
      state.messagingToken = token;
    },
    setUserNotifications: function setUserNotifications(state, notifications) {
      //console.log("setUser: ",notifications)
      state.userNotifications = notifications;
    },
    set_projects: function set_projects(state, data) {
      state.projects = data;
    },
    set_catalogs: function set_catalogs(state, data) {
      state.catalogs = data;
    }
  },
  actions: {
    getValidDomains: function getValidDomains(context) {
      return DomainService.get_valid_domains().then(function (response) {
        context.commit('setValidDomains', response.data.domains);
      }).catch(function (error) {
        return console.error('Error cargando dominios válidos:', error);
      });
    },
    setValidDomains: function setValidDomains(state, domains) {
      state.validDomains = domains;
    },
    setDeployVersion: function setDeployVersion(context, val) {
      context.commit('setDeployVersion', val);
    },
    setFlags: function setFlags(context, flags) {
      if (Object.keys(flags).includes('dataplex_active')) {
        context.commit('setHasDataplexActive', flags.dataplex_active);
      }
      if (Object.keys(flags).includes('hub_ia_active')) {
        context.commit('setHasHubIaActive', flags.hub_ia_active);
      }
      if (Object.keys(flags).includes("udc_active")) {
        context.commit("setHasDataplexCatalogActive", flags.udc_active);
      }
      if (Object.keys(flags).includes('semantic_search_active')) {
        context.commit('setHasSemanticSearchActive', flags.semantic_search_active);
      }
    },
    guardarfiltrosbusqueda: function guardarfiltrosbusqueda(context, nuevoObjeto) {
      context.commit('guardarfiltrosbusqueda', nuevoObjeto);
    },
    setProjects: function setProjects(context, data) {
      //console.log("setprojects",data)
      context.commit('set_projects', data);
    },
    setCatalogs: function setCatalogs(context, data) {
      context.commit('set_catalogs', data);
    },
    getSelectFields: function getSelectFields(context, domain) {
      MasterDataService.getSelectFields(domain).then(function (response) {
        var data = response.data;
        var business_domains = data.business_domains;
        var selectDomain = [];
        business_domains.forEach(function (business_domain) {
          selectDomain.push({
            kdomain: business_domain.kdomain,
            value: business_domain.kdomain,
            text: business_domain.domain,
            organization: business_domain.organization
          });
        });
        var selectSubdomain = [];
        var business_subdomains = data.business_subdomains;
        business_subdomains.forEach(function (business_subdomain) {
          var domain = selectDomain.find(function (e) {
            return e.kdomain === business_subdomain.kdomain;
          });
          selectSubdomain.push({
            domain: domain.value,
            domain_text: domain.text,
            value: business_subdomain.ksubdomain,
            text: business_subdomain.subdomain
          });
        });
        data['business_domains'] = selectDomain;
        data['business_subdomains'] = selectSubdomain;
        context.commit('set_select_fields', data);
      }).catch(function (error) {
        console.error(error);
      });
    },
    getInitialSetup: function getInitialSetup(context) {
      return InitialSetupService.getInitialSetup().then(function (response) {
        context.commit('set_initial_setup_records', response);
      }).catch(function (error) {
        console.error(error);
      });
    },
    getLoginDetail: function getLoginDetail(context, _this) {
      console.log('get login detail');
      var userLogin = firebase.auth().currentUser;
      var user = {
        email: userLogin.email ? userLogin.email.toLowerCase() : userLogin.email,
        uid: userLogin.uid,
        displayName: userLogin.displayName,
        emailVerified: userLogin.emailVerified,
        phoneNumber: userLogin.phoneNumber,
        photoURL: userLogin.photoURL,
        created: userLogin.metadata.creationTime,
        lastSignIn: userLogin.metadata.lastSignInTime
      };
      return user_security_service.loginDetail(window.userInfo.email, window.userInfo.accessToken, window.userInfo.uid, user).then(function (res) {
        window.userInfo.listOrgs = res.data.list_orgs;
        window.userInfo.orgs = res.data.orgs;
        window.userInfo.photoURL = userLogin.photoURL;
        window.userInfo.base_url = res.data.inca_base_url;
        window.userInfo.somos1_agreement = res.data.somos1_agreement;
        context.commit('setBaseUrl', res.data.inca_base_url);
        context.commit('setDefaultLanguage', res.data.defaultLanguage);
        context.commit('setCompanyCode', res.data.companyCode);
        context.commit('setCompanyName', res.data.companyName);
        context.commit('setOrgs', res.data.orgs);
        context.commit('setMessagingToken', res.data.messagingToken);
        _this.setLocale(res.data.defaultLanguage);
      });
    },
    hideInitialSetupMenu: function hideInitialSetupMenu(context) {
      return InitialSetupService.hideMenu().then(function (response) {
        var contInitialMenu = MENU_DICT.filter(function (rec) {
          return rec.href && rec.href.name === 'ContInitialSetup';
        });
        if (contInitialMenu.length && response && response.data) {
          contInitialMenu[0].hidden = true;
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    getIsTableauActive: function getIsTableauActive(context, domain) {
      return VisualizationService.getInitialData(domain).then(function (response) {
        context.commit('setIsTableauActive', response && response.data);
      }).catch(function (error) {
        console.error(error);
      });
    },
    getCompanyCode: function getCompanyCode(context) {
      return MasterDataService.getCompanyInfo().then(function (response) {
        context.commit('setCompanyCode', response.data.code);
      });
    },
    setMainQueryBy: function setMainQueryBy(context, queryBy) {
      context.commit('setMainQueryBy', queryBy);
    },
    setMainQueryText: function setMainQueryText(context, mainQueryText) {
      context.commit('setMainQueryText', mainQueryText);
    },
    setMainQueryAdvance: function setMainQueryAdvance(context, query) {
      context.commit('setMainQueryAdvance', query);
    },
    getBusinessDomainQuery: function getBusinessDomainQuery(context) {
      var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (domain == null) {
        domain = window.userInfo.domain;
      }
      var businessDomain = {
        domain: domain
      };
      var selectDomain = [];
      var selectSubdomain = [];
      return businessDomainService.getBusinessDomains(businessDomain).then(function (response) {
        for (var i = 0; i < response.data.result.length; i++) {
          selectDomain.push({
            kdomain: response.data.result[i].kdomain,
            value: response.data.result[i].kdomain,
            text: response.data.result[i].domain,
            organization: response.data.result[i].organization
          });
        }
      }).then(function () {
        businessSubdomainService.getBusinessSubdomains(businessDomain).then(function (response) {
          var _loop = function _loop(i) {
            var idx = selectDomain.findIndex(function (Domain) {
              return Domain.kdomain === response.data.result[i].kdomain;
            });
            selectSubdomain.push({
              domain: selectDomain[idx].value,
              domain_text: selectDomain[idx].text,
              value: response.data.result[i].ksubdomain,
              text: response.data.result[i].subdomain
            });
          };
          for (var i = 0; i < response.data.result.length; i++) {
            _loop(i);
          }
        });
      }).then(function () {
        //console.log(selectSubdomain.length, selectSubdomain)
        context.commit('setSelectDomain', selectDomain);
        context.commit('setSelectSubdomain', selectSubdomain);
      }).catch(function (error) {
        console.error(error);
      });
    },
    getProfilingValidationType: function getProfilingValidationType(context) {
      return ValidationTypeService.getProfilingValidationTypes().then(function (response) {
        context.commit('setSelectProfilingValidationType', response);
      }).catch(function (error) {
        console.error(error);
      });
    },
    getProfilingScoreFieldType: function getProfilingScoreFieldType(context) {
      return ProfilingScoreService.getProfilingScoreFieldTypes().then(function (response) {
        context.commit('setProfilingScoreFieldType', response);
      }).catch(function (error) {
        console.error(error);
      });
    },
    getProfilingScoreTableRule: function getProfilingScoreTableRule(context) {
      return ProfilingScoreService.getProfilingScoreTableRule().then(function (response) {
        context.commit('setProfilingScoreTableRule', response);
      }).catch(function (error) {
        console.error(error);
      });
    },
    getProfilingExecutions: function getProfilingExecutions(context, params) {
      return DataProfilingService.getProfilingExecutions(params).then(function (response) {
        context.commit('setProfilingExecutions', response);
      }).catch(function (error) {
        console.error(error);
      });
    },
    getSelectBusinessTerm: function getSelectBusinessTerm(context, table) {
      var businessDomain = {
        page: 1,
        limit: 500,
        clauses: {},
        domain: window.userInfo.domain
      };
      var selectDomain = [];
      return businessTermService.getBusinessTerms(businessDomain).then(function (response) {
        for (var i = 0; i < response.data.result.length; i++) {
          selectDomain.push({
            kdomain: response.data.result[i].kdomain,
            ksubdomain: response.data.result[i].ksubdomain,
            value: response.data.result[i].kbusiness_term,
            text: response.data.result[i].business_term,
            definition: response.data.result[i].definition,
            shared: response.data.result[i].shared || false
          });
        }
      }).then(function () {
        context.commit('setSelectBusinessTerm', selectDomain);
      }).catch(function (error) {
        console.error(error);
      });
    },
    getUserNotifications: function getUserNotifications(context) {
      var email = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!email) {
        email = window.userInfo.email;
      }
      return userSettingsService.getUserNotifications(email).then(function (response) {
        //console.log("from store")
        context.commit('setUserNotifications', response.data);
      });
    },
    getSynapseStatus: function getSynapseStatus(context, domain) {
      //console.log("aqui_master_data", domain)
      var aux = {};
      return DomainService.get_maintenance({
        domain: domain
      }).then(function (response) {
        console.log('aqui_master_data', response);
        if (response.data.synapse_config) {
          aux = response.data.synapse_config;
        } else {
          aux = {};
        }
        context.commit('setSynapseStatus', aux);
      }).catch(function (error) {
        console.error(error);
      });
    },
    getBigqueryStatus: function getBigqueryStatus(context, domain) {
      var aux = {};
      return DomainService.get_maintenance({
        domain: domain
      }).then(function (response) {
        if (response.data.bigquery_config) {
          aux = response.data.bigquery_config;
        } else {
          aux = {};
        }
        context.commit('setBigqueryStatus', aux);
      }).catch(function (error) {
        console.error(error);
      });
    }
  }
  // })
};
// export default store